<template>
  <el-collapse
    v-model="collapseModel"
    :accordion="true"
  >
    <el-collapse-item
      title="Pedidos"
      name="orders"
    >
      <div>
        <el-tooltip
          :disabled="!!ordenProduccion.Cliente?.Codigo"
          content="Debe seleccionar un cliente"
          placement="top"
        >
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            style="margin-bottom: 16px"
            :disabled="!ordenProduccion.Cliente?.Codigo"
            @click="importOrder"
          >
            Importar Pedido
          </el-button>
        </el-tooltip>

        <el-row
          :gutter="12"
          style="font-weight: bold"
        >
          <el-col :span="1">Item</el-col>
          <el-col :span="4">Código de Pedido</el-col>
          <el-col :span="4">Código de Producto</el-col>
          <el-col :span="4">Cantidad Imputada</el-col>
        </el-row>
        <InputPedidosItem
          v-for="(pedido, index) in pedidos"
          :key="index"
          :index="index"
          :pedido="pedido"
        />
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import IconAdd from '~icons/mdi/add';
import InputPedidosItem from '@/shared/components/input_pedidos_item.vue';
import { useWorkOrderStore } from '../../views/work_orders/stores/work_order_store';
import { useOrderImportStore } from '@/views/order_import/stores/order_import_store';

const workOrderStore = useWorkOrderStore();
const { modalPedidosVisible, ordenProduccion } = storeToRefs(workOrderStore);

const orderImportStore = useOrderImportStore();

const collapseModel = ref([]);

const props = defineProps({
  pedidos: { type: Array, required: false, default: () => [] },
  codigoCliente: { type: Number },
  clientes: { type: Array, default: null },
  codigoElementoGrupo: { type: Number },
});

const importOrder = () => {
  orderImportStore.setFilters({
    CodigoCliente: props.codigoCliente,
    CodigoElementoGrupo: props.codigoElementoGrupo,
    Estado: { Codigo: 1 },
  });
  modalPedidosVisible.value = true;
};
</script>

<style scoped>
.custom-label {
  font-weight: 700;
  color: #111;
}

.button-position {
  display: flex;
  justify-content: flex-end;
}

.add-button {
  margin-left: auto;
}
</style>
